export class JumpLinks {
  constructor() {
    this.links = document.querySelectorAll(".jump-link");
  }

  /**
   * scrollToPosition
   * Scrolls the target element into view, with a negative offset accounting for the fixed header, which will cover some of the content from view
   * @param {HTMLElement} targetElement
   */
  scrollToPosition(targetElement) {
    const yOffset = -200;
    const y =
      targetElement.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }

  /**
   * setUpScrollListeners
   * Sets up the listeners which will cause the window to scroll to a particular position once clicked
   * @param {HTMLElement} jumpLink
   */
  setUpScrollListeners(jumpLink) {
    jumpLink.addEventListener("click", () => {
      const scrollTargetId = `#${jumpLink.dataset.jumpTo}`;
      const scrollTargetElement = document.querySelector(scrollTargetId);
      this.scrollToPosition(scrollTargetElement);
    });
  }

  run() {
    this.links.forEach((jumpLink) => {
      console.dir(jumpLink.dataset);
      this.setUpScrollListeners(jumpLink);
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const jumpLinks = new JumpLinks();
  jumpLinks.run();
});

export default function initJumpLinks() {
  const jumpLinks = new JumpLinks();
  jumpLinks.run();
}
